import $ from "jquery";

const SearchCondition = function () {
  // MODAL
  class Modal {
    constructor(el) {
      this.data = {
        illust: {
          segment: ["イラスト", "デザイン", "CG"],
        },
        engineer: {
          segment: ["フロントエンド", "バックエンド", "インフラ"],
        },
      };
      // トリガー
      this.$trigger = $(el);
      // 職種などのカテゴリ名
      this.$cat = $(".c-modal__cat");
      // 具体的な選択肢名
      this.$segment = $(".c-modal__segment");
      // モーダル自体
      this.$modal = $(".c-modal");
      // モーダルオーバーレイ
      this.$overlay = $(".c-modal__overlay");
      // 選択肢ボタンの親要素
      this.$selects = $(".c-modal__selects");
      // ボタン
      this.btn = document.getElementsByClassName("c-modal__btn");
      // 追加ボタン
      this.$addBtn = $(".c-modal__addBtn");
      this.handler();
    }
    handler() {
      let self = this;
      // Trigger Click
      this.$trigger.on("click", function () {
        self.$trigger = $(this);

        const text = this.cloneNode(true);
        // span.c-numを削除
        text.querySelector("span") && text.querySelector("span").remove();
        self.setText(text.textContent);
        self.show();
        self.bodyFix();
        self.setBtn(this.getAttribute("data-segment"));
      });
      // Overlay Click
      this.$overlay.on("click", function () {
        self.bodyRelease();
        self.hide();
        self.textReset();
      });
      // Btn Click
      $(document).on("click", ".c-modal__btn", function () {
        $(this).toggleClass("is-active");
        self.addCondition();
        SearchBtn.functions();
      });

      // Add Click
      this.$addBtn.on("click", function () {
        self.addCondition();
        self.bodyRelease();
        self.hide();
        self.textReset();
        SearchBtn.functions();
      });
    }
    // モーダル内のテキストを初期化
    textReset() {
      this.$cat.html();
      this.$segment.html();
      this.$selects.children().remove();
    }
    setText(text) {
      this.$segment.html(text);
    }
    // モーダル表示
    show() {
      if (this.$modal.hasClass("is-init")) {
        this.$modal.show();
      } else {
        this.$modal.fadeIn();
      }
    }
    // モーダル非表示
    hide() {
      if (this.$modal.hasClass("is-init")) {
        this.$modal.hide();
      } else {
        this.$modal.fadeOut();
      }
    }
    bodyFix() {
      $("body").addClass("is-fixed");
    }
    bodyRelease() {
      $("body").removeClass("is-fixed");
    }
    // モーダル内のボタンを用意
    setBtn(segment) {
      let self = this;
      let children = self.$trigger.attr("data-children").split(",");
      if (self.$trigger.hasClass("c-btn01--has-num")) {
        // 既に条件追加済みの場合
        let hasData = self.$trigger.attr("data-search").split(",");
        let flag = false;
        children.forEach(function (v) {
          // this.data[segment].segment.forEach(function (v) {
          flag = false;
          hasData.forEach(function (k) {
            if (k === v) {
              flag = true;
            }
          });
          // 選択済みであればis-active
          if (flag) {
            self.$selects.append(
              `<li class="c-modal__item"><button data-segment="${v}" class="c-modal__btn c-btn01 is-active">${v}</button></li>`
            );
          } else {
            self.$selects.append(
              `<li class="c-modal__item"><button data-segment="${v}" class="c-modal__btn c-btn01">${v}</button></li>`
            );
          }
        });
      } else {
        // 条件追加がない場合
        children.forEach(function (v) {
          // this.data[segment].segment.forEach(function (v) {
          self.$selects.append(
            `<li class="c-modal__item"><button data-segment="${v}" class="c-modal__btn c-btn01">${v}</button></li>`
          );
        });
      }
    }
    // モーダルで選択したボタンの条件を追加
    addCondition() {
      // is-activeの数だけループする
      let len = this.$selects.children().children(".is-active").length;
      if (len > 0) {
        // 存在する場合
        let getSegment = [];
        let el = this.$selects.children().children(".is-active");
        el.each(function (i, v) {
          getSegment.push($(v).attr("data-segment"));
        });
        this.$trigger
          .attr("data-search", getSegment)
          .addClass("c-btn01--has-num is-active");

        // <span>要素を削除する
        this.$trigger.find(".c-num").remove();

        // <span>要素を追加する
        this.$trigger.append(`<span class="c-num">${len}</span>`);
      } else {
        // 存在しない場合
        this.$trigger
          .attr("data-search", "")
          .removeClass("c-btn01--has-num is-active");
        this.$trigger.children(".c-num").remove();
      }
    }
  }
  new Modal($(".c-btn01--has-modal"));

  // ALL SELECT
  $(".js-allSelect").on("click", () => {
    $(".c-modal__selects")
      .children()
      .children(".c-btn01")
      .addClass("is-active");
  });

  // ALL REJECT
  $(".js-allReject").on("click", () => {
    $(".c-modal__selects")
      .children()
      .children(".c-btn01")
      .removeClass("is-active");
  });

  // SEARCH
  class Search {
    constructor(el) {
      // ボタン
      this.$trigger = $(el);
      // 記事
      this.$articles = $(".c-article");
      // 検索結果数
      this.$num = $(".result__num");
      // 検索条件
      this.$conditions = $(".result__conditions");
      this.handler();
    }
    handler() {
      let self = this;
      this.$trigger.on("click", function () {
        self.activate(this);
        self.functions();
      });
    }
    activate(el) {
      if ($(el).hasClass("c-btn01")) {
        $(el).toggleClass("is-active");
      }
    }
    functions() {
      const tags = this.getSearchTags();
      this.showResult(tags);
      this.setConditionsText(tags);
      this.setNum();
    }
    getSearchTags() {
      // 検索条件タグを取得
      let tags = [[], [], []];
      this.$trigger.each(function (i, v) {
        if ($(v).hasClass("is-active")) {
          $(v)
            .attr("data-search")
            .split(",")
            .forEach(function (vv) {
              switch ($(v).data("cat")) {
                case 1:
                  tags[0].push(vv);
                  break;
                case 2:
                  tags[1].push(vv);
                  break;
                case 3:
                  tags[2].push(vv);
                  break;
              }
            });
        }
      });
      return tags;
    }
    showResult(tags) {
      this.$articles = $(".c-article");
      if (!tags.length) {
        this.$articles.parent().removeClass("is-hidden");
      } else {
        let self = this;
        this.$articles.parent().removeClass("is-hidden");
        // tagのカテゴリ分回す
        tags.forEach((tag) => {
          if (!tag.length) {
            return true;
          }
          // 記事分回す
          self.$articles.each(function (i, article) {
            // 現在選択しているタグ（検索条件）分回す
            let flag = false;
            tag.forEach(function (t) {
              // 記事の持つタグ
              let hasTags = $(article).attr("data-search").split(",");
              // 検索条件とタグの突合

              hasTags.forEach(function (k) {
                if (k === t) {
                  flag = true;
                  return true;
                }
              });
            });
            if (flag) {
              $(article).parent().removeClass("is-hidden");
            } else {
              $(article).parent().addClass("is-hidden");
            }
          });
          self.$articles = self.$articles.parent().not(".is-hidden").children();
        });
      }
    }
    setConditionsText(tags) {
      // 検索条件テキスト
      if (tags.length) {
        let str = "";
        tags.forEach((tag) => {
          if (tag.length) {
            str = str + tag.join(" | ") + " | ";
          }
        });
        str = str.slice(0, -3);
        this.$conditions.html("検索条件：" + str);
      } else {
        this.$conditions.html("検索条件：全て表示");
      }
    }
    setNum() {
      let result = this.$articles.parent().not(".is-hidden").length;
      if (result > 0) {
        this.$num.html(result);
        $(".result__unit").html("件該当しました");
        $(".noResult").remove();
      } else {
        this.$num.html(result);
        $(".result__unit").html("件");
        if (!document.querySelector(".noResult")) {
          $(".list").before(
            '<p class="noResult">条件に一致する職種が見つかりませんでした。<br>お手数ですが、条件を変更して再度お試しください。</p>'
          );
        }
      }
    }
  }
  let SearchBtn = new Search($(".js-search"));
  SearchBtn.setNum();

  // クエリパラメータに応じて検索結果を表示
  const url = new URL(location.href);
  const params = url.searchParams;
  const paramConditions = {
    location: params.get("location") && params.get("location").split(","),
    job: params.get("job") && params.get("job").split(","),
    employment: params.get("employment") && params.get("employment").split(","),
  };

  document.querySelector(".c-modal").classList.add("is-init");
  Object.keys(paramConditions).forEach((category) => {
    paramConditions[category] &&
      paramConditions[category].forEach((condition) => {
        let target;
        if (category === "location") {
          target = document.querySelector(
            `.js-search[name="place"][data-search="${condition}"]`
          );
        } else if (category === "job") {
          target = document.querySelector(
            `.js-search[name="occupation"][data-search="${condition}"]`
          );
          if (!target) {
            // モーダルの子ボタンをクリックする場合
            const modalTarget = document.querySelectorAll(
              `.js-search.c-btn01--has-modal[name="occupation"]`
            );

            modalTarget.forEach((el) => {
              const children = el.dataset.children.split(",");
              const index = children.indexOf(condition);

              if (index > -1) {
                // 親ボタンをクリックしてモーダルを表示
                el.click();
                // 子ボタンを取得
                target = document.querySelector(
                  `.c-modal__btn.c-btn01[data-segment="${children[index]}"]`
                );
              }
            });
          }
        } else if (category === "employment") {
          target = document.querySelector(
            `.js-search[name="status"][data-search="${condition}"]`
          );
        }
        target && target.click();

        document.querySelector(".c-modal__overlay").click();
      });
  });
  document.querySelector(".c-modal").classList.remove("is-init");
};

export default SearchCondition;



// WEBPACK FOOTER //
// ./src/recruit/js/searchCondition.js